// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"f1d78b08","895":"2910ec68","920":"f7e594db"}[chunkId] + ".chunk.js";
};